/* Built In Imports */
import NextLink from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

/* External Imports */
import {
  Box,
  Flex,
  Heading,
  Link,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
// import copy from 'copy-to-clipboard';
import { render } from 'datocms-structured-text-to-html-string';
import filter from 'lodash/filter';
import { nanoid } from 'nanoid';
import { useRouter } from 'next/router';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';
import { usePageType } from '@hooks/usePageType';
import { ProgramFeeSt } from '@ieo/Common/CompLangConfig';
import { gtmObject } from '@ieo/Components/Form/ieo/api/analyticsAPi';
import { useProgramLanguageSelection } from '@ieo/Components/Form/ieo/context/programLanguageSelectionContext';
import { programTypes } from '@ieo/Components/Form/ieo/utils';
import { usePageConfigValue } from '@ieo/hooks/usePageConfigVal';

/* Services */
/* Styles */

/**
 *
 * @param {Object} prgData
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @param {Object} pageData
 * @returns ProgramFee
 */
const RemrktProgramFees = ({
  sectionContent,
  region,
  lang,
  prgData,
  pageData,
}) => {
  const pathname = usePathname();
  // const [isOpen, setIsOpen] = useState(false);
  const priceData = Object?.values(prgData || '');
  // const [isGiftingFlow, setIsGiftingFlow] = useState();
  const { setProgramLanguage } = useProgramLanguageSelection();
  // const transProviderObj =
  //   (pageData._allSharedJsonLocales?.length &&
  //     pageData._allSharedJsonLocales[0]?.value.json) ||
  //   pageData.sharedJson?.json;
  const { isGiftPage } = usePageType();
  // const additionalText = sectionContent?.find(
  //   e => e.fieldId === 'additional-off'
  // );

  const programFeeDiscountText4 = sectionContent?.find(
    e => e.fieldId === 'program-fee-discount-4'
  );

  // const programFeeDiscountText5 = sectionContent?.find(
  //   e => e.fieldId === 'program-fee-discount-5'
  // );

  const programFeeAdditionalOff = sectionContent?.find(
    e => e.fieldId === 'additional-off'
  );

  const programFeeAdditionalOffVernacular = sectionContent?.find(
    e => e.fieldId === 'additional-off-vernacular'
  );

  const currentCoupon = Object.values(prgData)[0]?.coupon;

  const { pageConfigVal } = usePageConfigValue(pageData, region, currentCoupon);

  // const untilText = sectionContent?.find(e => e.fieldId === 'offer-until');
  const router = useRouter();
  // const isLandingOrPcPage =
  //   region === 'in' &&
  //   (router.asPath?.split('?')[0].endsWith('inner-engineering-pc') ||
  //     router.asPath?.split('?')[0].endsWith('inner-engineering'));

  // const isUS = pageData?.country === 'US';
  // const isCA = pageData?.country === 'CA';
  // console.log('sectionContent', sectionContent);

  const gtmClick = (lang, price) => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'IE_Language_Selected',
        IE_Lang: lang,
        IE_LP_Location: 'Language_Table',
      });

      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'add_to_wishlist',
        ecommerce: {
          currency: 'INR', // currency code (Ex - INR,USD,AUD etc.)
          value: price || priceData[0].discountedPrice || '',
          items: [
            {
              item_id: programTypes.IEO, // id of the program
              item_name: isGiftPage
                ? 'Gift Inner Engineering'
                : 'TYLS Inner Engineering', // Name of the program (Ex - TYLS Inner Engineering)
              affiliation: '',
              coupon: '',
              discount: 0, //Actual Discount if any (actual price - pay price)
              index: '',
              item_brand: '', // Country Code (Ex - US,IN etc.)
              item_category: '', // Language (Ex - English,Spanish etc.)
              item_category2: '', // Bay Name (not reuired for IE)
              item_category3: '', // New_User or Repeat_User
              item_category4: 'Language_Table',
              item_category5: '',
              item_list_id: '',
              item_list_name: '',
              item_variant: '',
              location_id: '',
              price: price || priceData[0].discountedPrice || '',
              quantity: '',
            },
          ],
        },
      });

      gtmObject({
        event: isGiftPage ? 'IE_Gift_Inner_Engineering' : 'IE_Register_Now',
        IE_LP_Location: 'Sticky_CTA',
        event1: 'view_item',
        item_name: isGiftPage
          ? 'Gift Inner Engineering'
          : 'TYLS Inner Engineering',
        item_category4: 'Language_Table',
      });
    }
  };
  let PriceDataList = [];
  if (region === 'in') {
    config.orderedLangList[lang].forEach(language => {
      const price = priceData.filter(item => {
        return item.lang === language.toUpperCase();
      });
      if (price.length > 0) {
        PriceDataList.push(price[0]);
      }
    });
  } else {
    PriceDataList = [...priceData];
  }
  const isIndian = region === 'in';
  // const changeUi = !isIndian;
  const changeUi =
    router.asPath.indexOf('inner-engineering-pc/rt-1') < -1 &&
    router.asPath.indexOf('inner-engineering-pc') > 0 &&
    isIndian;
  const [discountText, setDiscountText] = useState({});

  useEffect(() => {
    if (priceData?.length) {
      let filteredText = filter(pageConfigVal?.discounText, function (item) {
        return (
          item.code === priceData[0].coupon?.couponCode &&
          item.lang?.toLowerCase() === lang.toLowerCase()
        );
      });
      if (filteredText?.length) {
        setDiscountText(filteredText[0]);
      }
    }
  }, [priceData]);

  useEffect(() => {
    if (router.asPath.indexOf('/gift') > -1) {
      setIsGiftingFlow(true);
    }
  }, [router.asPath]);

  return (
    <Box bg="#fff">
      <Flex
        maxW={1030}
        bgRepeat="no-repeat"
        py={{ base: '60px', md: '50px' }}
        id="ieo-program-fees"
        mx="auto"
        // mt={{ base: '0px', md: '-140px' }}
      >
        <Flex
          w="full"
          mx="auto"
          flexWrap="wrap"
          px={{ base: changeUi ? '0' : '16px', xl: 0 }}
          pt={{
            base: '0px',
            md: lang === 'ar' ? '30px' : '80px',
            xl: '60px',
          }}
        >
          <Flex
            w="full"
            px={{ base: changeUi ? '16px' : '0', xl: 0 }}
            flexDir={{ base: 'column', lg: 'row' }}
            justifyContent="space-between"
            alignItems={{
              base: changeUi ? 'flex-start' : 'center',
              lg: changeUi ? 'center' : 'unset',
            }} // just remove for the older ui
            gridGap={{ base: '30px', md: '80px', '2xl': '70px' }}
            css={{
              '-webkit-grid-gap': '40px',
              '@media screen and (min-width: 768px)': {
                '-webkit-grid-gap': '80px',
              },
            }}
            pb="40px"
          >
            <Box
              color="#fff"
              w={{
                base: '100%',
                md: '60%',
                lg: '80%',
                xl: pageConfigVal?.prgFees?.offerBg?.desktop ? '65%' : '60%',
                '2xl': pageConfigVal?.prgFees?.offerBg?.desktop ? '65%' : '60%',
              }}
              display="flex"
              justifyContent="flex-start"
              flexDirection="column"
              alignItems={{
                base: lang === 'ar' ? 'flex-end' : 'center',
                lg: lang === 'ar' ? 'flex-end' : 'flex-start',
              }}
            >
              <Heading as="h2" {...ProgramFeeSt[lang].h2} color="#12166F">
                {sectionContent?.[0]?.titleText}
              </Heading>
              <StructuredTextParser
                mt="10px"
                str={render(sectionContent?.[1].body)}
                {...ProgramFeeSt[lang].p}
                maxW="auto"
                color="#F37021"
              />
              <StructuredTextParser
                mt="10px"
                str={render(sectionContent?.[2].body)}
                {...ProgramFeeSt[lang].p1}
                maxW="auto"
                color="#3B444B"
                textAlign={{ base: 'center', lg: 'start' }}
              />
            </Box>

            <Flex
              bg={`#fff`}
              bgRepeat="no-repeat"
              bgSize="cover"
              flexGrow="1"
              py={{ base: '20px', md: '30px' }}
              px={{ base: '20px', md: '70px' }}
              flexDir="column"
              boxShadow="0px 10px 33px #cecece"
            >
              <Flex
                alignItems={{ base: 'flex-start', md: 'center' }}
                gridGap="20px"
                css={{ '-webkit-grid-gap': '20px' }}
              >
                <Flex>
                  <svg
                    stroke="#be1931"
                    fill="#be1931"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    height="2.5em"
                    width="2.5em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M14 20.408c-.492.308-.903.546-1.192.709-.153.086-.308.17-.463.252h-.002a.75.75 0 0 1-.686 0 16.709 16.709 0 0 1-.465-.252 31.147 31.147 0 0 1-4.803-3.34C3.8 15.572 1 12.331 1 8.513 1 5.052 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262A31.146 31.146 0 0 1 14 20.408Z"></path>
                  </svg>
                </Flex>
                <StructuredTextParser
                  id="program-fee-text"
                  mt="0"
                  str={render(sectionContent?.[3].body)}
                  {...ProgramFeeSt[lang].feeDiscount1}
                  maxW="auto"
                  color="#6D6358"
                />
              </Flex>
              {/* Older Ui code */}
              {!changeUi && (
                <Box
                  borderBottom={{
                    base: '1px solid #6D6358',
                    md: '2px solid #6D6358',
                  }}
                  opacity={0.3}
                  mt="20px"
                />
              )}
              {!changeUi && priceData?.length > 0 && (
                <Flex
                  flexDir="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <StructuredTextParser
                    id={`${region}-${lang}-org-price`}
                    str={`${priceData[0]?.curr} ${priceData[0]?.pgmFee}`}
                    maxW="none"
                    textDecoration="line-through"
                    fontFamily="FedraSansStd-medium"
                    fontSize="26px"
                    color="#6D5358"
                    mt="20px"
                  />
                  {/* <StructuredTextParser
                    str={render(programFeeAdditionalOff?.body)}
                    maxW="none"
                    fontSize={{ base: '16px', md: '18px' }}
                    color="#9B7800"
                    lineHeight="28px"
                    fontFamily="FedraSansStd-book"
                  /> */}
                  <Flex
                    align="center"
                    direction="row"
                    gap={{ base: '5px', md: '10px' }}
                  >
                    <StructuredTextParser
                      id={`${region}-${lang}-dis-price`}
                      str={`${priceData[0]?.curr} ${priceData[0]?.discountedPrice}`}
                      maxW="none"
                      // textDecoration="line-through"
                      fontFamily="FedraSansStd-medium"
                      fontSize={{ base: '32px', md: '50px' }}
                      color="#CD9F00"
                      mt="2px"
                    />
                    {/* <Box
                      maxW="none"
                      mt="10px"
                      fontFamily="FedraSansStd-medium"
                      color="#CD9F00"
                      fontSize={{ base: '28px', md: '36px' }}
                      lineHeight="24px"
                    >
                      {priceData[0]?.curr}{' '}
                      {priceData[0]?.coupon?.postCouponPrice}
                    </Box> */}
                  </Flex>
                  {priceData.length > 1 && (
                    <>
                      <StructuredTextParser
                        str={render(programFeeDiscountText4?.body)}
                        maxW="none"
                        color="#A69786"
                        fontSize={{ base: '22px', md: '32px' }}
                        lineHeight="28px"
                        fontFamily="FedraSansStd-medium"
                        mt="26px"
                      />

                      <StructuredTextParser
                        id={`${region}-ver-org-price`}
                        str={`${priceData[1]?.curr} ${priceData[1]?.pgmFee}`}
                        maxW="none"
                        textDecoration="line-through"
                        fontFamily="FedraSansStd-medium"
                        fontSize="26px"
                        color="#6D5358"
                        mt="20px"
                      />

                      {/* <StructuredTextParser
                        str={render(programFeeAdditionalOffVernacular?.body)}
                        maxW="none"
                        fontSize={{ base: '16px', md: '18px' }}
                        color="#9B7800"
                        lineHeight="28px"
                        fontFamily="FedraSansStd-book"
                        mt="5px"
                      /> */}

                      <Flex
                        alignItems="center"
                        justifyContent="center"
                        gap={{ base: '5px', md: '10px' }}
                        mb="26px"
                        direction="row"
                      >
                        <StructuredTextParser
                          // id="program-fee-price"
                          id={`${region}-ver-dis-price`}
                          str={`${priceData[1]?.curr} ${priceData[1]?.discountedPrice}`}
                          maxW="none"
                          // textDecoration="line-through"
                          fontFamily="FedraSansStd-medium"
                          fontSize={{ base: '32px', md: '50px' }}
                          color="#CD9F00"
                          mt="2px"
                        />
                        {/* <Text
                          maxW="none"
                          mt="10px"
                          fontFamily="FedraSansStd-medium"
                          color="#CD9F00"
                          fontSize={{ base: '28px', md: '36px' }}
                          lineHeight="24px"
                        >
                          INR {priceData[1]?.coupon?.postCouponPrice}
                        </Text> */}
                      </Flex>
                    </>
                  )}
                </Flex>
              )}
            </Flex>
          </Flex>

          {sectionContent?.[9]?.table && prgData && (
            <Flex w="full" py={{ base: '30px', md: '80px' }}>
              <TableContainer
                whiteSpace="pre-wrap"
                bg="#fff"
                w="full"
                fontFamily="FedraSansStd-medium"
                boxShadow="0 10px 10px -6px #cbc7bb"
              >
                <Table variant="striped" colorScheme="blackAlpha">
                  <Thead bg="#B49168">
                    <Tr>
                      {sectionContent?.[9]?.table?.columns?.map(
                        (column, index) => (
                          <Th
                            display={{
                              base:
                                changeUi && index === 1 ? 'none' : 'table-cell',
                              md: 'table-cell',
                            }}
                            key={nanoid()}
                            textAlign="left"
                            {...ProgramFeeSt[lang].tableHead}
                            color="#fff"
                            lineHeight={{ base: '26px', xl: 'normal' }}
                            px={{ base: '16px', lg: '50px' }}
                            py={{ base: '15px', md: '30px' }}
                            textTransform="none"
                          >
                            {column}
                          </Th>
                        )
                      )}
                    </Tr>
                  </Thead>
                  <Tbody>
                    {PriceDataList?.map((item, index) => (
                      <Tr key={index}>
                        <Td
                          px={{ base: '16px', lg: '50px' }}
                          lineHeight={{ base: '26px', xl: 'normal' }}
                          color="#6D6358"
                          {...ProgramFeeSt[lang].bodyTd}
                        >
                          {item['lang'] &&
                            config.lngList[item['lang']?.toLowerCase()]}
                        </Td>
                        {changeUi && (
                          <Td
                            px={{ base: '16px', lg: '50px' }}
                            display={{ base: 'none', md: 'table-cell' }}
                          >
                            <Text
                              as="del"
                              textDecor="line-through"
                              lineHeight={{ base: '26px', xl: 'normal' }}
                              color="#6D6358"
                              {...ProgramFeeSt[lang].bodyTd}
                            >
                              {isIndian && item['curr']} {item['pgmFee']}
                              {/* {item['pgmFee']} */}
                            </Text>
                          </Td>
                        )}
                        <Td
                          px={{ base: '16px', lg: '50px' }}
                          lineHeight={{ base: '26px', xl: 'normal' }}
                          color="#6D6358"
                          {...ProgramFeeSt[lang].bodyTd}
                        >
                          {/* uncomment to add price with discounted price in mobile */}
                          <Text
                            as="del"
                            textDecor="line-through"
                            lineHeight={{ base: '26px', xl: 'normal' }}
                            color="#6D6358"
                            display={{
                              base: changeUi ? 'auto' : 'none',
                              md: 'none',
                            }}
                            {...ProgramFeeSt[lang].bodyTd}
                          >
                            {isIndian && item['curr']} {item['pgmFee']}
                          </Text>
                          <Text>
                            {/* comment the below code to add inr */}
                            {item?.coupon ? (
                              <>
                                {item?.curr} {item?.coupon?.postCouponPrice}
                              </>
                            ) : (
                              <>
                                {isIndian && item['curr']}{' '}
                                {item['discountedPrice']}
                              </>
                            )}
                          </Text>
                        </Td>
                        {sectionContent?.[9]?.table?.columns.indexOf(' ') !==
                          -1 && (
                          <Td
                            px={{ base: '16px', lg: '50px' }}
                            lineHeight={{ base: '26px', xl: 'normal' }}
                            color="#6D6358"
                            wordBreak="auto-phrase"
                            {...ProgramFeeSt[lang].bodyTd}
                          >
                            <NextLink
                              href="#ieo-enroll-section"
                              //href={disabled ? '#' : currentUrl}
                              passHref
                              legacyBehavior
                            >
                              <Link
                                color="#F37021"
                                display="flex"
                                _hover={{ color: '#BC570F' }}
                                onClick={() => {
                                  // console.log('Called onClick', item.lang);
                                  setProgramLanguage(item.lang);
                                  gtmClick(item.lang, item['discountedPrice']);
                                }}
                              >
                                {pathname.indexOf('inner-engineering-v4') > -1
                                  ? 'Start My Transformation'
                                  : 'Register Now'}

                                {/* <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M9 20.5L17 12.5L9 4.5" stroke="#F37021" strokeWidth="2.66667" />
                                </svg> */}
                              </Link>
                            </NextLink>
                          </Td>
                        )}
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </Flex>
          )}
        </Flex>
        <style global>
          {`
            .thanksgiving:hover svg {
              fill: #E86F34;
              color: #E86F34;
            }
            .thanksgiving:hover {
              background: '#FAE4B8';
              color: '#FFFFFF';
            }
              `}
        </style>
      </Flex>
    </Box>
  );
};

export default RemrktProgramFees;
